import type { FC, ReactNode } from 'react';
import styles from '../styles/header-footer-layout.module.scss';
import { SvgIcon, type SvgIconName } from './svg-icon';

const HeaderFooterLayout: FC<{
    title: string;
    withFooter?: boolean;
    onHome: () => void;
    onLogout?: () => void;
    children: ReactNode;
}> = ({ title, withFooter = true, onHome, onLogout, children }) => {
    return (
        <div className={styles.main}>
            <Header title={title} onHome={onHome} onLogout={onLogout} />
            <div className={styles.content}>{children}</div>
            {withFooter && <Footer />}
        </div>
    );
};

const Header: FC<{
    title: string;
    onHome?: () => void;
    onLogout?: () => void;
}> = ({ title, onHome, onLogout }) => {
    return (
        <div className={styles.header}>
            <h1 className={styles.title}>{title}</h1>
            <div className={styles.rightElement}>
                {onHome && <HomeButton onClick={onHome} />}
                {onLogout && <LogoutButton onClick={onLogout} />}
            </div>
        </div>
    );
};

const Footer = () => {
    return (
        <div className={styles.footer}>
            <div className={styles.textBox}>
                <a href="https://u-phone.net/about" target="_blank">
                    企業情報
                </a>
                <span>｜</span>
                <a
                    href="https://www.assurant.co.jp/%E3%83%97%E3%83%A9%E3%82%A4%E3%83%90%E3%82%B7%E3%83%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC"
                    target="_blank"
                >
                    プライバシーポリシー
                </a>
            </div>
        </div>
    );
};

const HeaderActionButton: FC<{
    iconName: SvgIconName;
    title: string;
    onClick: () => void;
}> = ({ iconName, title, onClick }) => {
    return (
        <button className={styles.headerActionButton} type="button" onClick={onClick}>
            <SvgIcon name={iconName} />
            <span className={styles.title}>{title}</span>
        </button>
    );
};

const HomeButton: FC<{
    onClick: () => void;
}> = ({ onClick }) => {
    return <HeaderActionButton iconName="home" title="TOPへ戻る" onClick={onClick} />;
};

const LogoutButton: FC<{
    onClick: () => void;
}> = ({ onClick }) => {
    return <HeaderActionButton iconName="exit" title="ログアウト" onClick={onClick} />;
};

export default HeaderFooterLayout;
